import type { BffApiClient } from "@/app/api-client"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import {
  type NftSearchItem,
  NftSort,
  StatusFilterOption,
} from "@anaconda/core/nft/search/types"

export type QueryInput = {
  collectionId: CollectionId
  blockchains: Blockchain[]
}

export const getCollectionFloorItemQueryParams = (
  apiClient: BffApiClient,
  queryInput: QueryInput,
) => ({
  queryKey: ["collections", "floorItem", queryInput],
  queryFn: async (): Promise<{
    nftWithFloorPrice: NftSearchItem | undefined
  }> => {
    const input = {
      sort: NftSort.LOW_PRICE_FIRST,
      pageSize: 1,
      filters: {
        status: StatusFilterOption.BUY_NOW,
        blockchains: queryInput.blockchains,
        collection: queryInput.collectionId,
      },
    }

    const response = await apiClient.api.nfts.search.$post({
      json: { ...input },
    })

    if (!response.ok) {
      const errorData = await response.json()
      console.error(
        "[Collection Floor Item Error]",
        response.status,
        errorData,
        "\nRequest params:",
        input,
      )
      throw errorData
    }

    const { nfts } = await response.json()
    const [nftWithFloorPrice] = nfts

    return { nftWithFloorPrice }
  },
})

type QueryFn = ReturnType<typeof getCollectionFloorItemQueryParams>["queryFn"]

export type QueryResponse = Awaited<ReturnType<QueryFn>>
